import React, { useRef, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useStyles } from "../../styles/SignDialog";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";
import "../../styles/devices/mob_SignDialog.css";
import { withStyles } from "@mui/styles";
import { LinearProgress } from "@material-ui/core";

const StyledDialog = withStyles({
  root: {},
  paper: {},
  backdrop: {
    pointerEvents: "none",
  },
})((props) => (
  <Dialog
    {...props}
    // disableBackdropClick={true}
    BackdropProps={{ onClick: () => {}, style: { pointerEvents: "none" } }}
    onClick={() => {}}
  />
));


export function SimpleVideoDialog(props) {
  const { openDialog, selected_video, selected_label, handleClickClose, repetitions_video } = props;
  const styles = useStyles();
  const videoRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [playCount, setPlayCount] = useState(0);

  useEffect(() => {
    if (openDialog) {
      setVideoLoaded(false);
    }
  }, [openDialog]);

  

  const handleVideoEnded = () => {
    if (playCount >= repetitions_video - 1) {
        setPlayCount(0)
        handleClickClose();
    }else{
        setPlayCount(playCount + 1);
        videoRef.current.play();
    }
  };

  const handleVideoLoaded = () => {
    setVideoLoaded(true);
  };

  return (
    <Dialog className="sig_SignModal_Dialog" open={openDialog} onClose={handleClickClose}>
        <DialogTitle>
            <div className="sig_Game_DialogTitle">
                {selected_label}
            </div>
            <IconButton aria-label="close" className="sig_Game_CloseButton" onClick={handleClickClose}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent className="sig_SignModal_DialogContent">
            <div className="sig_SignModal_VideoContainer">
              {!videoLoaded && <LinearProgress className={styles.videoLoading} color="primary" />}
              <video ref={videoRef} className={styles.signVideo} autoPlay muted onLoadedData={handleVideoLoaded} onEnded={handleVideoEnded}>
                <source src={selected_video} type="video/mp4" />
              </video>
            </div>
        </DialogContent>
    </Dialog>
  );
}